export const prices = {
  id37_test: 119,
  id37_test_with_friends_and_family: 29.75,
  friends_and_family_discount_in_percentage: 75
};
